import { useState } from "react";
import Close from "./icons/Close";
export default function Card({ nft }) {
    const [openModal, setOpenModal] = useState(false);
    const toggleModal = () => setOpenModal(!openModal)

    return (
        <div>
            <div className={"fixed inset-0 z-10 flex items-center justify-center transition-opacity duration-200 " + (openModal ? "opacity-100" : "opacity-0 pointer-events-none")}>
                <div className="fixed inset-0 transition-opacity bg-gray-900/75" aria-hidden="true"onClick={toggleModal}  >
                    <div className="fixed flex items-center justify-center inset-0 z-10 overflow-y-auto ">
                        <div className="flex items-center justify-center  text-center ">
                            <div className="relative max-w-5xl overflow-hidden text-left transition-all transform shadow-xl rounded-xl sm:my-8 sm:w-full">
                                <div className="relative bg-purple-rosa w-[300px] min-h-[500px] max-h-[560px] md:h-[550px] md:max-h-[550px]  lg:max-h-[600px] lg:h-[600px] md:w-[820px] lg:w-[870px] rounded-xl">
                                    <div className="flex flex-wrap  text-center sm:mt-0 sm:text-left">
                                        <img
                                            src={nft.image}
                                            alt={nft.name}
                                            className="w-[300px] h-[300px] lg:w-[600px] lg:h-[600px] md:w-[550px] md:h-[550px]"
                                        />
                                        <span className="absolute cursor-pointer top-4 right-4" onClick={toggleModal}>
                                            <Close width={16} />
                                        </span>
                                        <div className="w-full md:w-[270px] flex flex-col justify-center md:justify-start text-center lg:flex-1">
                                            <h3 className="lg:text-64 md:text-50 text-40 h-[55px] text-white md:h-[75px] lg:h-[90px]  ">
                                                #{nft.properties.edition}
                                            </h3>
                                            <div className="flex md:flex-col flex-wrap items-center justify-center h-full gap-[5px] pb-[20px] md:pb-[0px]">
                                                {
                                                    nft.attributes.map((attribute) =>
                                                        <div className="flex flex-col items-center justify-start rounded-[5px] md:rounded-[10px] bg-darker h-[43px] w-[110px] md:h-[60px] lg:h-[65px] md:w-[220px] lg:w-w-[220px]">
                                                            <p className="text-10 h-[10px] md:text-16 md:h-[9px] lg:h-[10px]">{attribute.trait_type}</p>
                                                            <p className="text-16 h-[19px] md:text-32 md:h-[32px] lg:h-[36px] ">{attribute.value}</p>
                                                            <p className="text-10 h-[12px] md:text-14 md:h-[10px] lg:h-[10px] ">XX.X%</p>
                                                        </div>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="flex flex-col">
                <div className="bg-darker w-[140px] md:w-[200px] rounded-t-[15px] cursor-pointer" onClick={toggleModal}>
                    <img
                        src={nft.image}
                        alt={nft.name}
                        className="rounded-b-none rounded-2xl md:w-[200px] md:h-[200px]"
                    />
                </div>
                <div className="bg-purple-light md:w-[200px] md:h-[40px] rounded-b-[15px] pt-[1px] md:pt-[3px] flex justify-center md:text-2xl text-sm cursor-pointer">
                    <span>{nft.name}</span>
                </div>
            </div>
        </div>
    );
}